export interface Branch {
  name: string;
  id: string;
}

export const BRANCHES: Branch[] = [
  { name: "Kho tổng", id: "66847e41-5b66-4529-b955-e63c7e8b50b0" },
  {
    name: "NHÀ THUỐC PHARCECO - MAI ĐỘNG",
    id: "527cff6e-db67-49b6-9e6d-150d27e760ce",
  },
  {
    name: "NHÀ THUỐC PHARCECO - XUÂN PHƯƠNG",
    id: "59022194-b4ea-4bf2-838c-1b11a055a7f3",
  },
  {
    name: "NHÀ THUỐC PHARCECO - NGUYỄN KHUYẾN",
    id: "1c773a52-8218-4749-b517-0b2823531067",
  },
  {
    name: "NHÀ THUỐC PHARCECO - YÊN XÁ",
    id: "03b696f6-af73-4927-98dd-424204ca78a9",
  },
  {
    name: "NHÀ THUỐC PHARCECO - CHÍNH KINH",
    id: "11734016-7153-4581-8d79-1eed546f87ce",
  },
  {
    name: "NHÀ THUỐC PHARCECO - LẠC LONG QUÂN",
    id: "55a1ca71-8536-43b2-bb8d-3e0cae3ae6d1",
  },
  {
    name: "NHÀ THUỐC PHARCECO - AN DƯƠNG",
    id: "a3e8c20e-0594-45ab-bf26-a789ad6aae09",
  },
  {
    name: "NHÀ THUỐC PHARCECO - LẠC TRUNG",
    id: "c7b62a0e-4c35-46d5-a19f-b7efb3002eee",
  },
  {
    name: "NHÀ THUỐC PHARCECO - NGUYỄN VIẾT XUÂN",
    id: "0d41034b-1491-41e0-a5d5-9fc22ff870e3",
  },
  {
    name: "NHÀ THUỐC PHARCECO - KẾ VẼ",
    id: "5dd16191-bdcd-4185-a6f8-79eb6747126d",
  },
  {
    name: "NHÀ THUỐC PHARCECO - CỔ NHUẾ",
    id: "40ea358b-1def-4496-a309-af372871cfa2",
  },
];

export function getBranchNameById(branchId: string): string {
  const branch = BRANCHES.find((b) => b.id === branchId);
  return branch ? branch.name : branchId;
}
